import { apiFetch } from "./client";

export const fetchBrands = () =>
  apiFetch("/enduser/brands/");
